import { makeAutoObservable, runInAction } from 'mobx'
import { products as defaultProducts } from '../constants/products'

export interface IProduct {
  id?: string
  guid?: number
  title?: string
  reports: IProductReport[]
}

export interface IProductReport {
  name: string
  id: string
  planId: number
  productId: number
  sections?: {
    [key: string]: string
  }
  isSnapshot?: boolean
  snapshotId?: string
  description?: string
}

/**
 * ProductStore manages product and report data.
 */
class ProductStore {
  loadingReports = false
  reports = []
  products = [] as IProduct[]
  currentProductObj: IProduct | null = null
  error = ''

  constructor() {
    makeAutoObservable(this)
    this.setProducts(defaultProducts)
    this.setCurrentProductById('pa')
  }

  /**
   * Sets the current product.
   * @param product - The product to set as current.
   */
  setCurrentProduct = (product: IProduct) => {
    this.currentProductObj = product
  }

  /**
   * Sets the current product by its ID.
   * @param productId - The ID of the product to set as current.
   */
  setCurrentProductById = (productId: string) => {
    const product = this.products.find(p => p.id === productId)
    if (product) {
      this.setCurrentProduct(product)
    } else {
      console.error(`Product with ID ${productId} not found`)
    }
  }

  /**
   * Sets the list of products.
   * @param products - The products to set.
   */
  setProducts = (products: IProduct[]) => {
    this.products = products
  }

  /**
   * Gets a report by its ID.
   * @param reportId - The ID of the report to get.
   * @returns The report with the specified ID.
   */
  getReport = (reportId: string) => {
    return this.products.find(report => report.id === reportId) || {}
  }

  /**
   * Gets the current product.
   * @returns The current product.
   */
  get currentProduct() {
    return this.currentProductObj?.id
  }
}

export default ProductStore
